import { sygnet } from './sygnet'
import { logo } from './logo'
import { logoNegative } from './logo-negative'
import { sx11 } from './sx11'
import { fx1000 } from './fx1000'
import { fx1000s } from './fx1000s'
import { fx6000 } from './fx6000'

import {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cilMemory,
  cilAlarm,
  cilHome,
  cilText,
  cilContact,
  cilHealing,
  cilHighlighter,
  cilHighligt,
  cibRollupJs,
  cibRoundcube,
  cilBatteryAlert,
  cibSpreaker,
  cilPencil,
  cilTrash,
  cibAddthis,
  cilArrowLeft,
  cilPlus,
  cilScrubber,
  cilAccountLogout,
  cilLockUnlocked,
  cibVerizon,
  cilSettings,
  cilBluetooth,
  cilLan,
  cilWifiSignal0,
  cilShieldAlt,
  cilZoomIn,
  cilUser,
  cilOptions,
  cilObjectGroup,
  cilCameraControl,
  cilLockLocked,
  cilInfo,
  cilCloudDownload,
  cilFindInPage,
  cibCodesandbox,
  cilFilter,
  cilAvTimer,
  cilDescription,
  cilDollar,
  cilEuro,
  cilCopy,
  cilClipboard,
  cilTruck,
  cilMinus,
  cilCheck,
  cilX,
  cilTransfer,
  cilPhone,
  cilMediaStop,
  cilColorPalette,
  cilColorFill,
  cilMenu,
  cilWallpaper,
  cibAmazon,
  cilGraph,
  cibZalando
} from '@coreui/icons'

import {
  cilExclamation,
  cilStore,
  cilEye,
  cilCalculator,
  cilCloudUpload,
  cilTrashX
} from '@coreui/icons-pro'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative,
  sx11,
  fx1000,
  fx1000s,
  fx6000
}, {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,
  cibZalando,
  cilMemory,
  cilAlarm,
  cilX,
  cilCloudDownload,
  cilTruck,
  cilArrowLeft,
  cilAccountLogout,
  cilExclamation,
  cilHome,
  cilText,
  cilContact,
  cilHealing,
  cilCheck,
  cilEye,
  cilCalculator,
  cilCloudUpload,
  cilHighlighter,
  cilHighligt,
  cibRollupJs,
  cibRoundcube,
  cilBatteryAlert,
  cibSpreaker,
  cilPencil,
  cilTrash,
  cibAmazon,
  cilStore,
  cibAddthis,
  cilPlus,
  cilMinus,
  cilScrubber,
  cilLockUnlocked,
  cibVerizon,
  cilSettings,
  cilBluetooth,
  cilClipboard,
  cilLan,
  cilWifiSignal0,
  cilShieldAlt,
  cilZoomIn,
  cilUser,
  cilOptions,
  cilObjectGroup,
  cilCameraControl,
  cilLockLocked,
  cilInfo,
  cilFindInPage,
  cibCodesandbox,
  cilFilter,
  cilAvTimer,
  cilDescription,
  cilDollar,
  cilEuro,
  cilCopy,
  cilTrashX,
  cilPhone,
  cilTransfer,
  cilMediaStop,
  cilColorPalette,
  cilColorFill,
  cilMenu,
  cilWallpaper,
  cilGraph
})
